import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { faMessageMusic } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { Avatar } from '@components/basics/Images/Avatar';
import { FeedPostModal } from '@components/modals/FeedPostModal';
import { useAuth } from '@context/auth/base';
import { ModalType, useModal } from '@context/modal';

export function FeedPostInput({ className = '' }: { className?: string }) {
  const { authUser } = useAuth();
  const { openModal } = useModal();

  if (!authUser) {
    return null;
  }

  return (
    <div className={twMerge('flex w-full gap-2', className)}>
      <Avatar
        walletAddress={authUser.publicAddress}
        username={authUser.username}
        webappUri={authUser.webappUri}
        size={48}
        src={authUser.avatar?.url}
        borderRadius={999}
      />
      <button
        className="relative flex flex-1 items-center rounded-md bg-base100 px-3 py-2 text-base-l text-neutral500 hover:bg-base300"
        onClick={() => {
          openModal(ModalType.FEED_POST, { body: <FeedPostModal /> });
        }}
      >
        <div className="flex-1 text-left">{`What sound is on your mind${
          authUser.displayName ? `, ${authUser.displayName}...` : '?'
        }`}</div>
        <FontAwesomeIcon icon={faMessageMusic} className=" flex-00auto" size="lg" />
      </button>
    </div>
  );
}
